export function normalizeSession(payload) {
  const source = payload && typeof payload === 'object' ? payload : {};

  return {
    ...source,
    user: source.user || null,
    gamification: source.gamification || null,
    features: {
      receipt_redemptions: source.features?.receipt_redemptions === true,
      receipt_redemptions_available: source.features?.receipt_redemptions_available === true,
      receipt_redemptions_beta_enabled: source.features?.receipt_redemptions_beta_enabled === true,
      receipt_redemptions_beta_required: source.features?.receipt_redemptions_beta_required !== false,
    },
    entries: {
      ...(source.entries || {}),
      items: Array.isArray(source.entries?.items)
        ? source.entries.items
        : Array.isArray(source.entries)
          ? source.entries
          : [],
      limit: Number(source.entries?.limit || 0),
      loaded: Number(source.entries?.loaded || 0),
      partial: source.entries?.partial === true,
    },
    totals: source.totals || null,
    inventory: source.inventory && typeof source.inventory === 'object'
      ? {
        ...source.inventory,
        items: Array.isArray(source.inventory.items) ? source.inventory.items : [],
      }
      : null,
    wallet: source.wallet || null,
    expeditions: source.expeditions || null,
    shipyard: source.shipyard || null,
    harbor_orders: source.harbor_orders || null,
    harbor_duels: source.harbor_duels || null,
    ship_game: source.ship_game || null,
    steps: source.steps || { todaySteps: 0, totalSteps: 0 },
    announcements: {
      ...(source.announcements || {}),
      items: Array.isArray(source.announcements?.items) ? source.announcements.items : [],
      unread_count: Number(source.announcements?.unread_count || 0),
    },
    meta: {
      ...(source.meta || {}),
      server_truth: true,
      storage: 'ram_only',
      bootstrapped_at: source.meta?.bootstrapped_at || new Date().toISOString(),
    },
  };
}

function mergeObjects(previous, incoming) {
  if (!incoming || typeof incoming !== 'object' || Array.isArray(incoming)) {
    return incoming;
  }

  const base = previous && typeof previous === 'object' && !Array.isArray(previous) ? previous : {};
  return {
    ...base,
    ...incoming,
  };
}

export function applySessionPatch(previousSession, patch) {
  if (!patch || typeof patch !== 'object') {
    return previousSession;
  }

  const nextSession = { ...(previousSession || {}) };

  Object.entries(patch).forEach(([key, value]) => {
    if (value === undefined) return;
    if (key === 'session_patch') {
      Object.assign(nextSession, applySessionPatch(nextSession, value));
      return;
    }
    if (key === 'entries' && Array.isArray(value)) {
      nextSession.entries = { ...(nextSession.entries || {}), items: value, loaded: value.length };
      return;
    }
    if (key === 'inventory' && Array.isArray(value)) {
      nextSession.inventory = { ...(nextSession.inventory || {}), items: value };
      return;
    }
    nextSession[key] = mergeObjects(nextSession[key], value);
  });

  return normalizeSession(nextSession);
}

export function createLatestLoadGuard() {
  let current = 0;
  return {
    begin() {
      current += 1;
      return current;
    },
    isCurrent(loadId) {
      return loadId === current;
    },
    invalidate() {
      current += 1;
    },
  };
}
